import { motion } from "framer-motion";
import { BellRing } from "lucide-react";
import { APP_SCREENSHOTS } from "../../lib/site";

// Premium phone frame containing a real RenewTracker app screenshot.
export const PhoneMockup = ({ image = APP_SCREENSHOTS.dashboard, className = "", floatBadge = true, alt = "RenewTracker app screen" }) => {
  return (
    <div className={`relative ${className}`} data-testid="phone-mockup">
      <div className="relative mx-auto w-[280px] sm:w-[300px]">
        {/* Device frame */}
        <div className="relative rounded-[2.75rem] border-[10px] border-ink bg-ink shadow-[0_40px_80px_-20px_rgba(15,23,42,0.45)]">
          <div className="relative w-full overflow-hidden rounded-[2.1rem] bg-[#f8fafc]">
            <img
              src={image}
              alt={alt}
              className="block h-auto w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        {/* Floating reminder badge — represents the real email/push reminder feature */}
        {floatBadge && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 10 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="absolute -right-6 top-28 hidden rounded-2xl border border-slate-100 bg-white px-4 py-3 shadow-xl sm:block"
          >
            <div className="flex items-center gap-2">
              <span className="grid h-8 w-8 place-items-center rounded-full bg-greenaccent/15">
                <BellRing className="h-4 w-4 text-greenaccent" />
              </span>
              <div>
                <p className="text-[11px] font-semibold text-ink">Reminder sent</p>
                <p className="text-[10px] text-slate-500">Before expiry</p>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default PhoneMockup;
